import { pointerWithin, rectIntersection, getFirstCollision } from "@dnd-kit/core"

// Custom collision detection strategy for multiple containers
export const collisionDetectionStrategy = (args: any) => {
    // Start by finding any intersecting droppable
    const pointerIntersections = pointerWithin(args)
    const intersections =
        pointerIntersections.length > 0
            ? pointerIntersections
            : rectIntersection(args)

    let overId = getFirstCollision(intersections, 'id')

    if (overId != null) {
        return [{ id: overId }]
    }

    return []
}